import { WsCore } from './ws.core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { api2 } from './api2';

export class WsAccessControl extends WsCore {
     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
     }

     validate() {
          return this.http
               .post(api2() + '/api/accessControl/instantPlanningOb', {})
               .toPromise();
     }
}
